import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from './../auth.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  userid: any;
  password: any;
  disableLoginButton = false;
  isActive = false;
  token!: any;
  disableLogin = false;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    // Redirect to dashboard if logged in else clear LOCALSTORAGE
    if (this.authService.getIsAuth()) {
      this.router.navigate(['/dashboard']);
    } else localStorage.clear();

    this.loginForm = this.formBuilder.group({
      userid: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(10),
        ],
      ],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  trimEmail() {
    this.userid = this.userid.trim();
  }

  login() {
    // Calling localStorage will trigger logout from all other tabs and create a new session
    localStorage.clear();
    let data = {
      userId: this.userid,
      password: this.password,
    };
    this.authService.user_login(data).subscribe(
      (userData: any) => {
        let userDetail = userData.body;
        localStorage.setItem('userInfo', JSON.stringify(userDetail));
        let header: HttpHeaders = userData.headers;
        localStorage.setItem('jwt_token', header.get('Authorization') || '');
        localStorage.setItem('refToken', header.get('refreshToken') || '');
        localStorage.setItem('user_type', userDetail.userType);
        localStorage.setItem('healthFacilityId', userDetail.healthFacilityId);
        localStorage.setItem('email', userDetail.email);
        localStorage.setItem('fname', userDetail.firstName);
        localStorage.setItem('lname', userDetail.lastName);
        localStorage.setItem('mname', userDetail.middleName);
        localStorage.setItem('userId', userDetail.userId);
        localStorage.setItem('userTypeId', userDetail.userTypeId);
        localStorage.setItem('contactNumber', userDetail.contactNumber);
        localStorage.setItem('countryCode', userDetail.countryCode);
        localStorage.setItem(
          'systemPasswordChanged',
          userDetail.systemPasswordChanged
        );
        localStorage.setItem('phtype', '2');
        this.snackBar.open('Login Successful', '', {
          duration: 2000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
        });
        if (userDetail.systemPasswordChanged === false) {
          this.router.navigate(['/change-password']);
        } else {

          this.spinner.hide().then(()=> {

            this.spinner.show('test').then(()=> {
              this.router.navigate(['/dashboard/home']);
            })
          })
          this.snackBar.open('You have successfully logged in', '', {
            duration: 2000,
            horizontalPosition: 'end',
            verticalPosition: 'bottom',
          });
        }
      },
      (error: any) => {
        if(error.status === 401) {
          this.loginForm.controls['password'].setErrors({authFailed: true});
        }
        const message = error.error?.message || 'Something went wrong';
        this.snackBar.open(message, '', {
          duration: 2000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
        });
      }
    );
  }
}
